import React from 'react';
import './Navigation.css';

function Navigation() {
  return (
    <div className="blue20-background">
      <nav className="container navbar navbar-expand-lg main-navbar-nav">
        <a className="navbar-brand" href="/">
          <img src={`${process.env.PUBLIC_URL}/img/playbook-logo.svg`} alt="Logo" className="playbook-logo img-fluid" />
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      </nav>
    </div>
  );
}

export default Navigation;
